import { numberToGermanLocaleWithThousandSeperator } from "../helper/formatting-helper";
import React from "react";
import PropTypes from "prop-types";

export const DocumentLineItem = (props) => {
    return (
        <>
            <tr style={{ background: props.color, borderTop: "2px solid lightgrey" }}>
                <td>{props.lineItem.title ?
                    props.lineItem.title
                        .replace("${REPAYMENT_DIFFERENCE}", props.locale.REPAYMENT_DIFFERENCE)
                        .replace("${DUTY}", props.locale.DUTY)
                    : ""}</td>
                <td>{props.lineItem.description ?
                    props.lineItem.description
                        .replace("${REPAYMENT_DIFFERENCE}", props.locale.REPAYMENT_DIFFERENCE)
                        .replace("${DUTY}", props.locale.DUTY)
                    : ""}</td>
                <td>{props.lineItem.quantity}</td>
                <td style={{ textAlign: "right" }}>
                    {numberToGermanLocaleWithThousandSeperator(props.lineItem.netPrice)}
                    {props.currencyCode}
                </td>
                {props.showDiscount && (
                    <td style={{ textAlign: "right" }}>
                        <ul
                            style={{
                                lineHeight: "1.3em",
                                marginBottom: "0",
                                listStyle: "none",
                            }}
                        >
                            {props.lineItem.discounts &&
                                props.lineItem.discounts.map((discount, discountIndex) => (
                                    <li key={discountIndex}>
                                        {numberToGermanLocaleWithThousandSeperator(discount)}
                                        {props.currencyCode}
                                    </li>
                                ))}
                        </ul>
                    </td>
                )}
                <td style={{ textAlign: "right" }}>
                    {props.lineItem.taxLines &&
                        props.lineItem.taxLines.map((taxLine, index) => {
                            return (
                                <div key={index}>
                                    {taxLine.taxRatePercentageString}
                                    <br />
                                </div>
                            );
                        })}
                </td>
                <td style={{ textAlign: "right" }}>
                    {props.lineItem.taxLines &&
                        props.lineItem.taxLines
                            .map((taxLine, index) => {
                                return (
                                    <div key={index}>
                                        {taxLine.mockItem
                                            ? "*"
                                            : numberToGermanLocaleWithThousandSeperator(taxLine.taxAmount) + props.currencyCode
                                        }
                                        <br />
                                    </div>
                                );
                            })}
                </td>
                <td style={{ textAlign: "right" }}>
                    {numberToGermanLocaleWithThousandSeperator(props.lineItem.totalAmount || null)}
                    {props.currencyCode}
                </td>
            </tr>

            {props.additionalInformationLineItems &&
                props.additionalInformationLineItems.map((additionalInformationLineItem, index) => {
                    return (
                        <tr style={{ background: props.color }} key={index}>
                            <td colSpan={props.showDiscount ? 8 : 7}>{additionalInformationLineItem.text}</td>
                        </tr>
                    );
                })}
        </>
    );
};

DocumentLineItem.propTypes = {
    lineItem: PropTypes.object.isRequired,
    currencyCode: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    additionalInformationLineItems: PropTypes.arrayOf(PropTypes.object),
    showDiscount: PropTypes.bool,
    locale: PropTypes.object.isRequired,
};
